import { Navigate, Outlet, RouteObject } from "react-router";
import { WorkOrderRoute } from "@/routes/processes/[processId]/rlt/work-orders/[workOrderId]/work-order-route";
import { WorkOrderIndexRoute } from "@/routes/processes/[processId]/rlt/work-orders/_components/work-order-index-route";
import { WorkOrdersCompletionRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/work-orders-completion-route";
import { WorkOrderCompletionRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/work-order-completion-route";
import { WorkOrderCompletionBaseDataRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/base-data/work-order-completion-base-data-route";
import { WorkOrderCompletionLmraRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/last-minute-risk-analysis/[lmraId]/work-order-completion-lmra-route";
import { WorkOrderCompletionCalculationRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/calculation/work-order-completion-calculation-route";
import { WorkOrderCompletionPricingRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/pricing/work-order-completion-pricing-route";
import { WorkOrderCompletionTreatmentRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/treatment/work-order-completion-treatment-route";
import { WorkOrderCompletionDocumentationRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/documentation/work-order-completion-documentation-route";
import { WorkOrdersExecutionRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/work-orders-execution-route";
import { WorkOrderExecutionRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/work-order-execution-route";
import { WorkOrderExecutionBaseDataRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/base-data/work-order-execution-base-data-route";
import { WorkOrderExecutionLmraRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/last-minute-risk-analysis/[lmraId]/work-order-execution-lmra-route";
import { WorkOrderExecutionTreatmentRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/treatment/work-order-execution-treatment-route";
import { WorkOrderExecutionDocumentationRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/documentation/[documentationId]/work-order-execution-documentation-route";
import { WorkOrdersPlanningRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/work-orders-planning-route";
import { WorkOrderPlanningRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/work-order-planning-route";
import { WorkOrderPlanningBaseDataRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/base-data/work-order-planning-base-data-route";
import { WorkOrderPlanningCalculationRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/calculation/work-order-planning-calculation-route";
import { WorkOrderPlanningPricingRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/pricing/work-order-planning-pricing-route";
import { WorkOrderPlanningTreatmentRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/treatment/work-order-planning-treatment-route";
import { WorkOrderCompletionFilesRoute } from "@/routes/processes/[processId]/rlt/work-orders/completion/[workOrderId]/files/work-order-completion-files-route";
import { WorkOrderExecutionFilesRoute } from "@/routes/processes/[processId]/rlt/work-orders/execution/[workOrderId]/files/work-order-execution-files-route";
import { WorkOrderPlanningFilesRoute } from "@/routes/processes/[processId]/rlt/work-orders/planning/[workOrderId]/files/work-order-planning-files-route";

export const workOrdersRoutes: RouteObject[] = [
  {
    index: true,
    element: <WorkOrderIndexRoute />,
  },
  {
    path: "completion",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersCompletionRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderCompletionRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="base-data" replace />,
          },
          {
            path: "base-data",
            element: <WorkOrderCompletionBaseDataRoute />,
          },
          {
            path: "last-minute-risk-analysis/:lmraId",
            element: <WorkOrderCompletionLmraRoute />,
          },
          {
            path: "calculation",
            element: <WorkOrderCompletionCalculationRoute />,
          },
          {
            path: "pricing",
            element: <WorkOrderCompletionPricingRoute />,
          },
          {
            path: "treatment",
            element: <WorkOrderCompletionTreatmentRoute />,
          },
          {
            path: "documentation/:documentationId",
            element: <WorkOrderCompletionDocumentationRoute />,
          },
          {
            path: "files",
            element: <WorkOrderCompletionFilesRoute />,
          },
        ],
      },
    ],
  },
  {
    path: "execution",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersExecutionRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderExecutionRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="base-data" replace />,
          },
          {
            path: "base-data",
            element: <WorkOrderExecutionBaseDataRoute />,
          },
          {
            path: "last-minute-risk-analysis/:lmraId",
            element: <WorkOrderExecutionLmraRoute />,
          },
          {
            path: "treatment",
            element: <WorkOrderExecutionTreatmentRoute />,
          },
          {
            path: "documentation/:documentationId",
            element: <WorkOrderExecutionDocumentationRoute />,
          },
          {
            path: "files",
            element: <WorkOrderExecutionFilesRoute />,
          },
        ],
      },
    ],
  },
  {
    path: "planning",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <WorkOrdersPlanningRoute />,
      },
      {
        path: ":workOrderId",
        element: <WorkOrderPlanningRoute />,
        children: [
          {
            index: true,
            element: <Navigate to="base-data" replace />,
          },
          {
            path: "base-data",
            element: <WorkOrderPlanningBaseDataRoute />,
          },
          {
            path: "calculation",
            element: <WorkOrderPlanningCalculationRoute />,
          },
          {
            path: "pricing",
            element: <WorkOrderPlanningPricingRoute />,
          },
          {
            path: "treatment",
            element: <WorkOrderPlanningTreatmentRoute />,
          },
          {
            path: "files",
            element: <WorkOrderPlanningFilesRoute />,
          },
        ],
      },
    ],
  },
  {
    path: ":workOrderId",
    element: <WorkOrderRoute />,
  },
];
